export const vm = {
  email: {
    required: 'Email address is required',
    invalid: 'Please enter a valid email address',
  },
  password: {
    required: 'Password is required',
    minLength: 'Password must be at least 8 characters',
    uppercase: 'Password must contain at least one uppercase letter',
    lowercase: 'Password must contain at least one lowercase letter',
    number: 'Password must contain at least one number',
  },
  firstName: { required: 'First name is required' },
  lastName: { required: 'Last name is required' },

  name: { required: 'Name is required' },
  quantity: { positive: 'Quantity must be greater than 0' },
  unit: { required: 'Unit is required' },
  itemType: { required: 'Type/Category is required' },

  groupName: {
    required: 'Group name is required',
    minLength: 'Group name must be at least 3 characters',
    maxLength: 'Group name must be less than 100 characters',
  },
  groupDescription: { maxLength: 'Description must be less than 500 characters' },

  mealTypeName: { required: 'Meal type name is required' },
  mealType: { required: 'Meal type is required' },
  meals: { required: 'Please select at least one meal to reuse' },

  recipe: { required: 'Please select a recipe from the list' },
  recipeTitle: { required: 'Title is required' },
  recipeDescription: { required: 'Description is required' },
  recipeCategory: { required: 'Category is required' },
  recipeIngredients: { required: 'At least one ingredient is required' },

  ingredientName: { required: 'Name is required' },
  ingredientType: { required: 'Type is required' },
  ingredientGroup: { required: 'Group is required' },

  date: { required: 'Please select at least one date' },

  shoppingListName: { required: 'Shopping list name is required' },
  startDate: { required: 'Start date is required' },
  endDate: { required: 'End date is required', afterStart: 'End date must be after start date' },
} as const
